/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
// import { CircularProgress } from "@material-ui/core";
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";


export function WidgetForDevices({ className, total, active, inActive }) {

    return (
        <div className={`card card-custom bg-gray-100 ${className}`}>
            {/* Header */}
            <div className="  border-0 bg-white ">
            </div>
            {/* Body */}
            <div className="rounded bg-white">
                {/* Stat */}
                <div className="card-spacer   ">
                    <div className="row mx-2">
                        <div style={{ height: "150px" }} className="col  shadow bg-light-primary px-6 py-8 rounded mr-7 mb-2">
                            <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Devices/CPU1.svg")}></SVG>
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Electric/Fan.svg")}></SVG>
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Bulb2.svg")}></SVG>
                                <span className="text-primary float-right font-weight-bold font-size-h1 mr-5">{total}</span>
                            </span>
                            <p className="text-primary font-weight-bold font-size-h6" >
                                Total Devices        </p>
                        </div>

                        <div className="col shadow  bg-light-success px-6 py-8 rounded mr-7 mb-2">
                            <span className="svg-icon svg-icon-3x svg-icon-success d-block my-2">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Devices/CPU1.svg")}></SVG>
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Electric/Fan.svg")}></SVG>
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Bulb2.svg")}></SVG>
                                <span className="text-success float-right font-weight-bold font-size-h1 mr-5">{active}</span>
                            </span>
                            <p className="text-success font-weight-bold font-size-h6 mt-2" >
                                Active Devices </p>
                        </div>

                        <div className="col shadow bg-light-danger px-6 py-8 rounded mb-2">
                            <span className="svg-icon svg-icon-3x svg-icon-danger d-block my-2">
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Devices/CPU1.svg")}></SVG>
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Electric/Fan.svg")}></SVG>
                                <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Bulb2.svg")}></SVG>
                                <span className="text-danger float-right font-weight-bold font-size-h1 mr-5">{inActive}</span>
                            </span>
                            <p className="text-danger font-weight-bold font-size-h6 mt-2" >
                                Inactive Devices </p>
                        </div>
                    </div>
                    <div className="row m-0">

                    </div>
                </div>

                {/* Resize */}
                <div className="resize-triggers">
                    <div className="expand-trigger">
                        <div style={{ width: "411px", height: "461px" }} />
                    </div>
                    <div className="contract-trigger" />
                </div>
            </div>
        </div>
    )

}
